import { styled } from "styled-components";

const PageContainer = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  margin: 0;
  width: 100vw;
  overflow: hidden;
  position: relative;
`;

export default PageContainer;
